import { render, staticRenderFns } from "./editReportCustomComponentFooter.vue?vue&type=template&id=1488d6c9"
import script from "./editReportCustomComponentFooter.vue?vue&type=script&lang=js"
export * from "./editReportCustomComponentFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports